import { Breadcrumbs, Typography, useTheme } from '@mui/material';

import TAGLink from '@shared-components-web/components/TAGLink';
import TAGSvgIcon from '@shared-components-web/components/TAGSvgIcon';
import { Maybe, Page } from '@src/lib/__generated/contentful/sdk';

export interface IBreadCrumbs {
	isFooterLite?: boolean;
	breadcrumbsData: Page;
}

const BreadCrumbs = ({ breadcrumbsData, isFooterLite = false, ...props }: IBreadCrumbs) => {
	const { breadcrumbsCollection, breadcrumbTitle } = breadcrumbsData;
	const breadcrumbs = breadcrumbsCollection?.items;
	const theme = useTheme();

	if (!breadcrumbs || breadcrumbs.length <= 0) {
		return null;
	}

	return (
		<Breadcrumbs
			{...props}
			separator={
				<TAGSvgIcon
					icon="ChevronRightFunc"
					size={12}
					htmlColor={isFooterLite ? theme.palette.text.interactive : theme.palette.text.light}
				/>
			}
			aria-label="breadcrumbs"
			data-testid="breadcrumbs_container"
		>
			{breadcrumbs.map((page: Maybe<Page>, index: number) => (
				<TAGLink key={`breadcrumb-${index}`} href={page?.path || ''} dataTestId={`breadcrumb_link_${index}`}>
					<Typography
						color={isFooterLite ? 'text.interactive' : 'text.light'}
						variant="bodySmallBook"
						title={page?.breadcrumbTitle || ''}
					>
						{page?.breadcrumbTitle}
					</Typography>
				</TAGLink>
			))}
			{breadcrumbTitle ? (
				<Typography
					variant="bodySmallBook"
					color={isFooterLite ? 'text.interactive' : 'text.light'}
					data-testid="breadcrumb_current_page_title"
				>
					{breadcrumbTitle}
				</Typography>
			) : null}
		</Breadcrumbs>
	);
};

export default BreadCrumbs;
